




















































import { defineComponent } from '@vue/composition-api';
const INFO_ICON = 'img:/questionnaire/icons/new_info.svg';
const AVATAR_WIDTH = '44px';

export default defineComponent({
  name: 'Migration',
  setup() {
    return { INFO_ICON, AVATAR_WIDTH };
  }
});
